<fc-general-modal [baseId]="baseId" [form]="form" [fcModalItemContext]="fcModalItemContext" (saveForm)="save()" (cancelForm)="onCancel()">
  <div [formGroup]="form">
    <div class="flex-row-generic">
      <div class="flex-item-three-columns">
        <div class="form-group">
          <label for="{{ baseId }}-id" translate>ID</label>
          <input
            id="{{ baseId }}-id"
            class="form-control"
            [ngClass]="{ error: showErrors(externalIdControl, isSubmitted),'required': isRequired(externalIdControl) }"
            type="text"
            [maxlength]="fcListValidation.validations.ExternalID.MaxLength"
            formControlName="externalId"
          />
          <div *ngIf="showErrors(externalIdControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-id" translate>
            {{ externalIdControl.errors | fcListValidation : 'ID' }}
          </div>
        </div>
      </div>
      <div class="flex-item-three-columns">
        <div class="form-group required">
          <label for="{{ baseId }}-zip" translate>ZIP</label>
          <input
            id="{{ baseId }}-zip"
            class="form-control"
            [ngClass]="{ error: showErrors(zipControl, isSubmitted), 'required': isRequired(zipControl) }"
            type="text"
            [maxlength]="10"
            formControlName="name"
          />
          <div *ngIf="showErrors(zipControl, isSubmitted) && showZipError" class="incorrect-input" id="{{ baseId }}-warning-text-zip" translate>
            {{ zipControl.errors | fcListValidation : 'ZIP' }}
          </div>
        </div>
      </div>
      <div class="flex-item-three-columns">
        <div class="form-group">
          <label for="{{ baseId }}-city" translate>City</label>
          <input
            id="{{ baseId }}-city"
            class="form-control"
            [ngClass]="{ error: showErrors(cityControl, isSubmitted), 'required': isRequired(cityControl) }"
            type="text"
            [maxlength]="fcListValidation.validations.City.MaxLength"
            formControlName="city"
          />
          <div *ngIf="showErrors(cityControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-city" translate>
            {{ cityControl.errors | fcListValidation : 'City' }}
          </div>
        </div>
      </div>
    </div>
    <div class="flex-row-generic">
      <div class="flex-item-three-columns">
        <div class="form-group">
          <label for="{{ baseId }}-state" translate>State</label>
          <input
            id="{{ baseId }}-state"
            class="form-control"
            [ngClass]="{ error: showErrors(stateControl, isSubmitted), 'required': isRequired(stateControl) }"
            type="text"
            [maxlength]="fcListValidation.validations.State.MaxLength"
            formControlName="state"
          />
          <div *ngIf="showErrors(stateControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-state" translate>
            {{ stateControl.errors | fcListValidation : 'State' }}
          </div>
        </div>
      </div>
      <div class="flex-item-three-columns">
        <div class="form-group">
          <label for="{{ baseId }}-area-code" translate>Area Code</label>
          <input
            id="{{ baseId }}-area-code"
            class="form-control"
            [ngClass]="{ error: showErrors(areaCodeControl, isSubmitted), 'required': isRequired(areaCodeControl) }"
            type="text"
            [maxlength]="3"
            formControlName="areaCode"
          />
          <div *ngIf="showErrors(areaCodeControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-area-code" translate>
            {{ areaCodeControl.errors | fcListValidation : 'Area Code' : { pattern: 'Area Code must be 3 digits' } }}
          </div>
        </div>
      </div>
    </div>

    <div class="form-group full-control">
      <label for="{{ baseId }}-notes" translate>Notes</label>
      <textarea
        class="form-control"
        [ngClass]="{ error: showErrors(notesControl, isSubmitted), 'required': isRequired(notesControl) }"
        id="{{ baseId }}-notes"
        formControlName="notes"
        [maxlength]="fcListValidation.validations.Notes.MaxLength"
        rows="3"
      >
      </textarea>
      <div *ngIf="showErrors(notesControl, isSubmitted)" class="incorrect-input" id="{{ baseId }}-warning-text-notes" translate>
        {{ notesControl.errors | fcListValidation : 'Notes' }}
      </div>
    </div>
    <div class="checkbox-group">
      <mat-checkbox id="{{ baseId }}-inactive-checkbox" formControlName="inactive" translate> Inactive </mat-checkbox>
      <mat-checkbox id="{{ baseId }}-user-defined-checkbox" formControlName="userDefined" translate> User Defined </mat-checkbox>
    </div>
  </div>
</fc-general-modal>
